import React, { useState, useEffect } from "react";
import "./styles.css";
import { Layout, theme } from "antd";
import { useDispatch } from "react-redux";
import { Route, Routes } from "react-router-dom";
import { useNavigate } from "react-router";
import { logout } from "../redux/slices/userslice";

import Header from "./Header";
import Siders from "./sider";

import DashboardScreen from "../screens/dashboardScreen";

import EPaperScreeen from "../screens/Epaper";
import EpaperForm from "../screens/Epaper/component/newform";
import UserScreen from "../screens/userscreen";
import CreateUser from "../screens/userscreen/components/newform";
import Subscriptionlist from "../screens/subscription";

function Routing() {
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const [userActivity, setUserActivity] = useState(false);

  const navigate: any = useNavigate();
  const dispatch = useDispatch();

  const resetUserActivity = () => {
    setUserActivity(false);
  };

  useEffect(() => {
    const handleUserActivity = () => {
      setUserActivity(true);
    };

    window.addEventListener("mousemove", handleUserActivity);
    window.addEventListener("keypress", handleUserActivity);

    const timeoutId = setTimeout(() => {
      if (!userActivity) {
        dispatch(logout(""));
        navigate("/");
      }
      resetUserActivity();
    }, 3600000);

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("mousemove", handleUserActivity);
      window.removeEventListener("keypress", handleUserActivity);
    };
  }, [userActivity]);

  return (
    <Layout>
      <Layout>
        <Siders />
        <Layout.Content>
          <Header />
          <div className="routeBox">
            <Routes>
              <Route path="/" element={<DashboardScreen />} />
              <Route path="/home" element={<DashboardScreen />} />
              <Route path="/Epaper" element={<EPaperScreeen />} />
              <Route path="/EpaperForm/:id" element={<EpaperForm />} />
              <Route path="/users" element={<UserScreen />} />
              <Route path="/users/form/:id" element={<CreateUser />} />
              <Route path="/listsubscrption" element={<Subscriptionlist />} />
            </Routes>
          </div>
        </Layout.Content>
      </Layout>
    </Layout>
  );
}

export default Routing;
